import React from 'react';
import { motion } from 'framer-motion';

const AdminPanel = ({
  title,
  subtitle,
  headerActions,
  children,
  footer,
  variant = 'default', // 'default', 'bordered', 'elevated'
  className = '',
  loading = false
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`admin-panel admin-panel-${variant} ${className}`}
    >
      {(title || headerActions) && (
        <div className="admin-panel-header">
          <div className="admin-panel-header-left">
            {title && <h3 className="admin-panel-title">{title}</h3>}
            {subtitle && <p className="admin-panel-subtitle">{subtitle}</p>}
          </div>
          {headerActions && (
            <div className="admin-panel-header-actions">
              {Array.isArray(headerActions) ? (
                headerActions.map((action, index) => (
                  <React.Fragment key={index}>{action}</React.Fragment>
                ))
              ) : (
                headerActions
              )}
            </div>
          )}
        </div>
      )}
      
      <div className="admin-panel-body">
        {loading ? (
          <div className="admin-panel-loading">
            <div className="admin-spinner" />
            <p className="admin-panel-loading-text">Loading...</p>
          </div>
        ) : (
          children
        )}
      </div>
      
      {footer && (
        <div className="admin-panel-footer">
          {footer}
        </div>
      )}
    </motion.div>
  );
};

export default AdminPanel;

